import { useEffect, useState } from "react";

import Button from "../button/button";
import useSpeakToTeach from "./speakToText";

const ComponentSpeakToTeach = ({ isOpenSpeakToTeach }) => {
  const [textInput, setTextInput] = useState("");

  const { isListening, transcript, startListening, stopListening } =
    useSpeakToTeach({ continuos: true });

  const startStopListening = () => {
    isListening ? stopVoiceInput() : startListening();
  };

  useEffect(() => {
    stopVoiceInput();
    setTextInput("");
    // eslint-disable-next-line
  }, [isOpenSpeakToTeach]);

  const stopVoiceInput = () => {
    setTextInput(
      (prevVal) =>
        prevVal +
        (transcript.length ? (prevVal.length ? " " : "") + transcript : "")
    );
    stopListening();
  };

  return (
    <div className="flex flex-col items-center space-y-4 w-full">
      <div className>
        <Button
          label={isListening ? "Detener" : "Presiona para hablar"}
          variant={isListening ? "red-button" : "primary"}
          onClick={() => startStopListening()}
          customClassName="w-full"
        />
      </div>
      <div className="w-[50%]">
        <textarea
          className="bg-transparent text-white p-4 rounded-lg w-full border border-white border-2 focus:border-blue-500 text-capitalize"
          disabled={isListening}
          value={
            isListening
              ? textInput +
                (transcript.length
                  ? (textInput.length ? " " : " ") + transcript
                  : "")
              : textInput
          }
          onChange={(e) => {
            setTextInput(e.target.value);
          }}
        />
      </div>
    </div>
  );
};

export default ComponentSpeakToTeach;
